/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_CoInputs */

const cs_projects_co = /** @type {(inputs: Projects_CoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo orientační`)
};

const en_projects_co = /** @type {(inputs: Projects_CoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orientation number`)
};

/**
* | output |
* | --- |
* | "Orientation number" |
*
* @param {Projects_CoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_co = /** @type {((inputs?: Projects_CoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_CoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_co(inputs)
	return cs_projects_co(inputs)
});